'use strict';
const angular = require('angular');

/*@ngInject*/
export function WebAccessService($resource) {
  return $resource('/api/webaccess/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/webaccess/:id/attachments"
    },
    getByContact: {
      method: 'GET',
      url: "/api/webaccess/by-contact/:contactId",
      isArray: true
    },
    resetPassword: {
      method: 'PUT',
      url: "/api/webaccess/reset-password/:id",
    },
    sendInvitations: {
      method: 'POST',
      url: "/api/webaccess/send-invitations"
    },
    getWebAccessEmail: {
      method: 'GET',
      url: "/api/webaccess/email/:webaccessId/:token"
    },
    activate: {
      method: 'PUT',
      url: "/api/webaccess/activate/:webaccessId"
    },
    updateLastLoggedIn: {
      method: 'PUT',
      url: "/api/webaccess/last-logged-in/:webaccessId"
    },
    queryIds: {
      method: 'GET',
      url: "/api/webaccess/ids",
      isArray: true
    },
    querySS: {
      method: 'POST',
      url: "/api/webaccess/datatables"
    },
    queryState: {
      method: 'GET',
      url: "/api/webaccess/state/:state",
      isArray: true
    }
  });
}


export default angular.module('conduu.WebAccessService', [])
  .factory('WebAccessService', WebAccessService)
  .name;



// WEBPACK FOOTER //
// ./client/components/webaccess/webaccess.service.js